module.exports = __webpack_public_path__ + "static/media/18x24no2.7d6a78bd.jpg";